/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_TitleInputs */

const vi_receipt_title = /** @type {(inputs: Receipt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HÓA ĐƠN THANH TOÁN`)
};

/**

* @param {Receipt_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_title = /** @type {((inputs?: Receipt_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_title(inputs)
});